import * as React from "react";
import { RouteComponentProps } from "@reach/router";
import { cx, css } from "@emotion/css";
import bootstrapStyles from "../../css/bootstrap.module.css";

const reviewLabelCSS = css`
  font-size: 15px;
  color: #666;
  margin-bottom: 16px;
`;
const reviewDataCSS = css`
  font-weight: 700;
  color: #555;
  margin-bottom: 16px;
  overflow-wrap: break-word;
`;

interface ReviewProps extends RouteComponentProps {
  id: string;
  reviewLabel: string;
  reviewData: string;
}

const ReviewData = ({ id, reviewLabel, reviewData }: ReviewProps) => {
  return (
    <div className={bootstrapStyles["col-md-6"]}>
      <div className={bootstrapStyles.row}>
        <div className={cx(bootstrapStyles["col-md-5"], reviewLabelCSS)}>
          {reviewLabel}
        </div>
        <div className={cx(bootstrapStyles["col-md-7"], reviewDataCSS)} id={id}>
          {reviewData}
        </div>
      </div>
    </div>
  );
};

export default ReviewData;
